import { useEffect, useState } from "react";
import "../../styles/Firmwares.css";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../../services/api";
import {
  MdOutlineFileUpload,
  MdPerson,
  MdLogout,
  MdRefresh,
  MdSearch,
  MdArrowBack,
} from "react-icons/md";

function Firmwares() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [allfirmwares, setallfirmwares] = useState<any[]>([]);

  // Filter API data
  const filtered = allfirmwares.filter((fw) =>
    fw.version?.toLowerCase().includes(search.toLowerCase())
  );

  const fetchallfirmwares = async () => {
    try {
      const response = await apiFetch("/firmware/all", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("HTTP error! Status");
      }

      const data = await response.json();
      setallfirmwares(data);
    } catch (err) {
      // console.error("Error fetching firmware data");
    }
  };

  useEffect(() => {
    fetchallfirmwares();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userName");
    localStorage.removeItem("userEmail");
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  const back = () => {
    navigate("/dashboard/firmwareupdate");
  };

  return (
    <div className="firmware-container">
      {/* Unified Top Header matching Dashboard Overview, Master MAC & Profile */}
      <div className="firmware-header">
        <div className="header-title-section">
          <h2>All Firmwares</h2>
          <p>Inspect certified firmware releases, release changelogs, and binary sizes</p>
        </div>

        <div className="firmware-header-actions">
          <button
            type="button"
            className="add-user-btn"
            onClick={() => navigate("/dashboard/firmwareupdate")}
            title="Upload New Firmware"
          >
            <MdOutlineFileUpload size={18} />
            <span>Upload Firmware</span>
          </button>

          <button
            type="button"
            className="user-btn-secondary profile-link-btn"
            onClick={() => navigate("/dashboard/profile")}
          >
            <MdPerson size={18} />
            <span>My Profile</span>
          </button>

          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <span
              className="round-header-icon"
              onClick={fetchallfirmwares}
              title="Refresh"
            >
              <MdRefresh size={20} color="#4b5563" />
            </span>
            <span
              className="round-header-icon logout"
              onClick={handleLogout}
              title="Logout"
            >
              <MdLogout size={18} color="#dc2626" />
            </span>
          </div>
        </div>
      </div>

      {/* Search Toolbar */}
      <div className="viewall-firmware">
        <div style={{ position: "relative", display: "inline-block" }}>
          <input
            type="text"
            placeholder="Search by version..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="search-box"
          />
        </div>
        <button className="bck-btn" onClick={back} style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
          <MdArrowBack size={16} /> Back to Upgrade
        </button>
      </div>

      {/* Table Card */}
      <div className="firmware-table-card">
        <table className="firmware-table">
          <thead>
            <tr>
              <th style={{ width: "60px", textAlign: "center" }}>SL No.</th>
              <th>Version</th>
              <th>Fixes</th>
              <th>Features</th>
              <th>Size</th>
            </tr>
          </thead>

          <tbody>
            {filtered.length > 0 ? (
              filtered.map((fw, index) => (
                <tr key={fw.id || index}>
                  <td style={{ textAlign: "center", color: "#9ca3af", fontWeight: 600 }}>
                    {index + 1}
                  </td>
                  <td style={{ fontWeight: 600, color: "#111827" }}>
                    {fw.version}
                    {fw.latest && (
                      <span
                        style={{
                          marginLeft: "8px",
                          fontSize: "11px",
                          fontWeight: 700,
                          padding: "2px 6px",
                          borderRadius: "4px",
                          background: "#ecfdf5",
                          color: "#065f46",
                        }}
                      >
                        Latest
                      </span>
                    )}
                  </td>
                  <td>{fw.fix || "—"}</td>
                  <td>{fw.features || "—"}</td>
                  <td style={{ color: "#6b7280" }}>
                    {fw.size ? `${(fw.size / 1024).toFixed(2)} KB` : "—"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center", padding: "30px", color: "#6b7280" }}>
                  No firmware found matching "{search}"
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Firmwares;